import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { FirebaseAppProvider } from "reactfire";
import config from "firebase-config";
import ReactLoading from "react-loading";
import { StylesProvider } from "@mui/styles";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import { CheatsContextProvider } from "context/CheatsContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    default: {
      light: "#eeeeee",
      main: "#212121",
      dark: "#000000",
      contrastText: "#f5f5f5",
    },
    primary: {
      main: "#ab47bc",
      light: "#df78ef",
      dark: "#790e8b",
      contrastText: "#f5f5f5",
    },
    secondary: {
      light: "#73e8ff",
      main: "#29b6f6",
      dark: "#0086c3",
      contrastText: "#000000",
    },
    rojo: {
      light: "#ff867f",
      main: "#ff5252",
      dark: "#c50e29",
      contrastText: "#000000",
    },
  },
});

ReactDOM.render(
  <FirebaseAppProvider firebaseConfig={config}>
    <CheatsContextProvider>
      <Suspense fallback="">
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>
            <HashRouter>
              <App />
            </HashRouter>
          </StyledEngineProvider>
        </ThemeProvider>
      </Suspense>
    </CheatsContextProvider>
  </FirebaseAppProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
